











































import {Vue, Component, Ref, Watch, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue'
import IClose from '@/components/icons/IClose.vue'
import ICopy from '@/components/icons/ICopy.vue'

const dialog = namespace('dialog')

@Component({
  components: {
    BtnDefault,
    IClose,
    ICopy,
  }
})
export default class ModalError extends Vue {
  @dialog.Getter('modalErrorShow') protected modalErrorShow: any
  @dialog.Getter('modalErrorTitle') protected modalErrorTitle: any
  @dialog.Getter('modalErrorCopyText') protected modalErrorCopyText: any
  @dialog.Mutation('SetModalError') protected SetModalError: any
  @dialog.Mutation('setSupportDialog') protected setSupportDialog: any

  @Prop({type: String, default: ''}) protected title!: string

  dialogSupport: boolean = false
  modalShow: boolean = true
  titles: any = {
    notSave: this.$t('error.modal.title'),
    someError: this.$t('error.modal.title_some'),
  }


  openSupport() {
    this.SetModalError({show: false})
    this.setSupportDialog(true)
  }

  @Watch('modalErrorShow')
  setModalShow() {
    this.modalShow = this.modalErrorShow
  }

  closeSupport() {
    this.dialogSupport = false
    this.SetModalError({show: false})
  }

  copy(value: any) {
    let area = document.createElement('textarea');
    document.body.appendChild(area);
    area.value = value;
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }

}

